
<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li>{{partnersText}}</li>
            </ul>
            <h2>{{partnersText}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Team Area -->
<section class="team-area pt-100 pb-70">

    <app-small-spinner [show]="showSpinner"></app-small-spinner>
    <div class="container">
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2" *ngFor="let partner of partners">
                <a href="javascript:;" class="d-block text-center">
                    <img  src="{{partner.image.fileUrl}}" alt="image">
                </a>
            </div>
        </div>
    </div>
    
</section>
<!-- End Team Area -->
